import firebase from 'firebase/compat/app';
import React, { useState } from 'react';
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Row
} from 'react-bootstrap';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { auth } from '../../../../firebase';
import { updateASUUserAndSubscribeInCategory } from '../../../../apis/register';
import { UserType } from '../../../../types/User';
import {
  displayEmailPasswordVerification,
  displayErrorMessage,
  userRegistrationInCategory
} from '../../../../utils/registerUtils';
import LoadingButton from '../../../../components/ui/button/LoadingButton';

interface RegisterInCategorySecondStepProps extends RouteComponentProps {
  user: UserType;
  category: string;
}

const RegisterInCategorySecondStep: React.FC<RegisterInCategorySecondStepProps> = ({
  user,
  category,
  history
}) => {
  const isNewUser = user.firebaseUserId === '';
  const [studentId, setStudentId] = useState(
    isNewUser || user.uid === null ? '' : user.uid
  );
  const [fullname, setFullname] = useState(!isNewUser ? user.name : '');
  const [email, setEmail] = useState(user.email);
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // validate form
  const requiredFields = isNewUser
    ? [fullname, password, repeatPassword, email, studentId]
    : [fullname, password, email, studentId];
  const isDisabled = requiredFields.some((field) => field === '');

  const handleSubmit = async () => {
    if (isNewUser) {
      userRegistrationInCategory(
        studentId,
        fullname,
        email,
        password,
        repeatPassword,
        category,
        history,
        setLoading
      );
    }

    if (!isNewUser) {
      try {
        await updateUserAccountAndLogin(email, password);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const updateUserAccountAndLogin = async (
    email: string,
    password: string
  ): Promise<void> => {
    setLoading(true);
    try {
      await auth.doSignInWithEmailAndPassword(email, password);

      const currentUser = firebase.auth().currentUser;
      if (currentUser) {
        if (currentUser.emailVerified) {
          const token = await currentUser.getIdToken();
          await updateASUUserAndSubscribeInCategory(token, {
            code: category,
            name: fullname,
            studentId
          });
          history.push('/dashboard');
        } else {
          displayEmailPasswordVerification(currentUser);
          firebase.auth().signOut();
        }
      }
    } catch (error) {
      setLoading(false);
      displayErrorMessage(error);
      firebase.auth().signOut();
    }
  };

  return (
    <>
      <Row>
        <Col xs={6} xsOffset={3}>
          <FormGroup controlId="studentId">
            <ControlLabel>ASURITE UserID [ dhmurph1 ]</ControlLabel>
            <FormControl
              value={isNewUser || user.uid === null ? studentId : '*********'}
              componentClass="input"
              className="styleFieldLoginInflo"
              type="text"
              onChange={(event) => {
                setStudentId(event.target.value);
              }}
              disabled={!(isNewUser || user.uid === null) || loading}
              placeholder="e.g. dhmurph1"
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col xs={6} xsOffset={3}>
          <FormGroup controlId="fullname">
            <ControlLabel>Name</ControlLabel>
            <FormControl
              value={fullname}
              componentClass="input"
              className="styleFieldLoginInflo"
              type="text"
              onChange={(event) => {
                setFullname(event.target.value);
              }}
              disabled={loading}
            />
          </FormGroup>
        </Col>
      </Row>
      {isNewUser && (
        <Row>
          <Col xs={6} xsOffset={3}>
            <FormGroup controlId="email">
              <ControlLabel>Email</ControlLabel>
              <FormControl
                value={email}
                componentClass="input"
                className="styleFieldLoginInflo"
                type="email"
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                disabled={loading}
              />
            </FormGroup>
          </Col>
        </Row>
      )}
      <Row>
        <Col xs={6} xsOffset={3}>
          <FormGroup controlId="password">
            <ControlLabel>
              {isNewUser ? 'Create New Password' : 'Inflo Password'}
            </ControlLabel>
            <FormControl
              value={password}
              componentClass="input"
              className="styleFieldLoginInflo"
              type="password"
              onChange={(event) => {
                setPassword(event.target.value);
              }}
              disabled={loading}
            />
          </FormGroup>
        </Col>
      </Row>
      {isNewUser && (
        <Row>
          <Col xs={6} xsOffset={3}>
            <FormGroup controlId="repeatPassword">
              <ControlLabel>Repeat New Password</ControlLabel>
              <FormControl
                value={repeatPassword}
                componentClass="input"
                className="styleFieldLoginInflo"
                type="password"
                onChange={(event) => {
                  setRepeatPassword(event.target.value);
                }}
                disabled={loading}
              />
            </FormGroup>
          </Col>
        </Row>
      )}
      <div style={{ textAlign: 'center', marginTop: '15px' }}>
        <LoadingButton
          isLoading={loading}
          onClick={handleSubmit}
          text={isNewUser ? 'Create Account' : 'Update Account'}
          disabled={isDisabled}
        />
      </div>
    </>
  );
};

export default withRouter(RegisterInCategorySecondStep);
